(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customsearchbox"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sections = document.querySelectorAll('.filtered-brand-collection');
  if (!sections.length) return;

  function normaliseSearch(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  sections.forEach(function(section) {
    const scroller = section.querySelector('[data-products-scroller]');
    const prevBtn = section.querySelector('[data-products-prev]');
    const nextBtn = section.querySelector('[data-products-next]');
    const rowWrappers = Array.from(section.querySelectorAll('.filtered-brand-collection__filters'));
    const searchInput = section.querySelector('.filtered-brand-collection__search-input');
    if (!scroller) return;

    let productCards = Array.from(section.querySelectorAll('[data-product-card]'));
    const rowFilters = {};
    let searchQuery = '';

    function getCardData(card) {
      if (card._kbData) return card._kbData;

      const tagsRaw = card.dataset.productTags || '';
      const tagsArr = tagsRaw
        .split('|')
        .map(function(t) { return t.trim(); })
        .filter(Boolean);

      const textBits = [
        card.dataset.searchText || '',
        tagsRaw,
        card.dataset.productType || '',
        card.dataset.productVendor || '',
        card.textContent || ''
      ].join(' ');

      const data = {
        tags: tagsArr,
        type: (card.dataset.productType || '').trim().toLowerCase(),
        vendor: (card.dataset.productVendor || '').trim().toLowerCase(),
        searchText: normaliseSearch(textBits)
      };

      card._kbData = data;
      return data;
    }

    function cardMatchesFilters(card, filtersMap) {
      const activeRows = Object.keys(filtersMap);
      const data = getCardData(card);

      if (searchQuery && data.searchText.indexOf(searchQuery) === -1) return false;
      if (!activeRows.length) return true;

      for (let i = 0; i < activeRows.length; i++) {
        const rowId = activeRows[i];
        const filter = filtersMap[rowId];
        if (!filter || !filter.value) continue;

        const value = filter.value;

        if (filter.kind === 'brand') {
          const matchesBrandInTags = data.tags.some(function(tag) {
            return tag === value || tag.indexOf(value) !== -1;
          });
          const matchesBrandInVendor = data.vendor === value || data.vendor.indexOf(value) !== -1;
          if (!matchesBrandInTags && !matchesBrandInVendor) return false;

        } else if (filter.kind === 'type') {
          const matchesTypeInTags = data.tags.some(function(tag) {
            return tag === value || tag.indexOf(value) !== -1;
          });
          const matchesTypeInType = data.type === value || data.type.indexOf(value) !== -1;
          if (!matchesTypeInTags && !matchesTypeInType) return false;
        }
      }

      return true;
    }

    function updateRowButtonsVisibility() {
      if (!rowWrappers.length || !productCards.length) return;

      rowWrappers.forEach(function(rowEl, idx) {
        const rowId = rowEl.dataset.filterRow || '';
        const buttons = rowEl.querySelectorAll('[data-filter-brand-button], [data-filter-type-button]');
        if (!rowId || !buttons.length) return;

        if (idx === 0) {
          buttons.forEach(function(btn) { btn.style.display = ''; });
          return;
        }

        const baseFilters = {};
        for (let i = 0; i < idx; i++) {
          const prevRowEl = rowWrappers[i];
          const prevRowId = prevRowEl.dataset.filterRow || '';
          if (prevRowId && rowFilters[prevRowId]) baseFilters[prevRowId] = rowFilters[prevRowId];
        }

        if (Object.keys(baseFilters).length === 0) {
          buttons.forEach(function(btn) { btn.style.display = 'none'; });
          return;
        }

        buttons.forEach(function(btn) {
          let kind = null;
          let value = '';

          if (btn.hasAttribute('data-filter-brand-button')) {
            kind = 'brand';
            value = (btn.dataset.filterBrand || '').trim();
          } else if (btn.hasAttribute('data-filter-type-button')) {
            kind = 'type';
            value = (btn.dataset.filterType || '').trim();
          }

          if (!kind || !value) {
            btn.style.display = 'none';
            return;
          }

          const testFilters = Object.assign({}, baseFilters);
          testFilters[rowId] = { kind: kind, value: value };

          const anyMatch = productCards.some(function(card) {
            return cardMatchesFilters(card, testFilters);
          });

          btn.style.display = anyMatch ? '' : 'none';
        });
      });
    }

    function updateVisibleRows() {
      if (!rowWrappers.length) return;

      rowWrappers.forEach(function(rowEl, idx) {
        const rowId = rowEl.dataset.filterRow || '';
        if (!rowId) return;

        if (idx === 0) { rowEl.style.display = ''; return; }

        let allPrevSelected = true;
        for (let i = 0; i < idx; i++) {
          const prevRowId = rowWrappers[i].dataset.filterRow || '';
          if (prevRowId && !rowFilters[prevRowId]) { allPrevSelected = false; break; }
        }

        rowEl.style.display = allPrevSelected ? '' : 'none';
      });
    }

    function applyFilters() {
      productCards.forEach(function(card) {
        const show = cardMatchesFilters(card, rowFilters);
        card.style.display = show ? '' : 'none';
      });

      updateRowButtonsVisibility();
      updateVisibleRows();
    }

    function setupNav() {
      if (!scroller || !prevBtn || !nextBtn) return;

      function updateNavState() {
        const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
        prevBtn.disabled = scroller.scrollLeft <= 5;
        nextBtn.disabled = scroller.scrollLeft >= maxScrollLeft - 5;
      }

      const scrollAmount = 320;

      prevBtn.addEventListener('click', function() {
        scroller.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function() {
        scroller.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      scroller.addEventListener('scroll', updateNavState);
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        searchQuery = normaliseSearch(searchInput.value);

        if (searchQuery.length > 0) {
          Object.keys(rowFilters).forEach(function(key) { delete rowFilters[key]; });
          rowWrappers.forEach(function(rowEl) {
            rowEl.querySelectorAll('[data-filter-brand-button], [data-filter-type-button]')
              .forEach(function(btn) { btn.classList.remove('is-active'); });
          });
        }

        applyFilters();
      });
    }

    rowWrappers.forEach(function(rowEl) {
      const rowId = rowEl.dataset.filterRow || '';
      if (!rowId) return;

      const buttons = rowEl.querySelectorAll('[data-filter-brand-button], [data-filter-type-button]');
      const rowIndex = rowWrappers.indexOf(rowEl);

      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          const isActive = btn.classList.contains('is-active');
          buttons.forEach(function(b) { b.classList.remove('is-active'); });

          if (isActive) {
            delete rowFilters[rowId];
          } else {
            btn.classList.add('is-active');

            if (btn.hasAttribute('data-filter-brand-button')) {
              const val = (btn.dataset.filterBrand || '').trim();
              if (val) rowFilters[rowId] = { kind: 'brand', value: val };
              else delete rowFilters[rowId];
            } else if (btn.hasAttribute('data-filter-type-button')) {
              const val = (btn.dataset.filterType || '').trim();
              if (val) rowFilters[rowId] = { kind: 'type', value: val };
              else delete rowFilters[rowId];
            }
          }

          rowWrappers.forEach(function(otherRowEl, idx) {
            if (idx <= rowIndex) return;
            const otherRowId = otherRowEl.dataset.filterRow || '';
            if (!otherRowId) return;

            delete rowFilters[otherRowId];
            otherRowEl.querySelectorAll('[data-filter-brand-button], [data-filter-type-button]')
              .forEach(function(b) { b.classList.remove('is-active'); });
          });

          applyFilters();
        });
      });
    });

    setupNav();
    updateVisibleRows();
    applyFilters();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
